import { Button } from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';

export interface PacketBuyedProps {
  back: () => void;
}

function PacketBuyed({back}: PacketBuyedProps) {
  const { t } = useTranslation();

  return (
    <div style={{display: 'flex', flexDirection: 'column'}}>
      <div style={{flex: '1 1 0', display: 'flex', gap: '10px', flexDirection: 'row', justifyContent: 'center', padding: '10px'}}>
        <p>{t('orderCompleteMsg')}</p>
      </div>
      <div style={{flex: '1 1 0', display: 'flex', flexDirection: 'row', justifyContent: 'center', padding: '10px'}}>
        <Button appearance="secondary" onClick={back}>{t('backHomeBtn')}</Button>
      </div>
    </div>
  );
}

export default PacketBuyed;
